import {graphql} from 'gatsby'
import React from 'react'

import {EventCtaActionedAction, partnerCtaActioned} from '@/analytics/segment'
import SimpleCardGrid from '@/sections/simple-card-grid'

import type {SimpleCardGridSliceFragment} from '@/graphql-types'

type Props = {
    slice: SimpleCardGridSliceFragment
}

export const SimpleCardGridSlice = ({slice}: Props) => {
    const trackingEvent = slice.primary.tracking_event

    return (
        <SimpleCardGrid
            title={slice.primary.title}
            cards={slice.items.map((card) => ({
                ...card,
                body: card.description,
                ctaLink: {
                    ...card.cta_link,
                    onClick: () => {
                        // This is an interim solution until we decide upon a more generalized one.
                        // We had to extend the EventData to accept all stings as TrackingEvents in order for this to work.
                        // So the TrackingEvent enum is essentially not restrictive for track calls.
                        if (trackingEvent === 'Partner Cta Actioned') {
                            partnerCtaActioned({
                                action: EventCtaActionedAction.Clicked,
                                value: card.title,
                            })
                        }
                    },
                },
                ctaText: slice.primary.card_cta_text,
            }))}
        />
    )
}

export const cardGridSliceFragment = graphql`
    fragment SimpleCardGridSlice on PrismicSlicePageDataBodySimpleCardGrid {
        __typename
        primary {
            title
            card_cta_text
            tracking_event
        }
        items {
            image {
                alt
                copyright
                url
                dimensions {
                    height
                    width
                }
                gatsbyImageData(breakpoints: $imageBreakpoints, sizes: $threeColumns)
            }
            title
            description
            cta_link {
                ...PrismicLink
            }
        }
    }
`
